exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.global-notification[data-v-5ef54cfa] {\n  bottom:0;\n  z-index:10070;\n  position:fixed !important;\n}\n.document_type_name[data-v-5ef54cfa] {\n  font-size: 16px;\n  line-height: 18px;\n  font-weight: 400;\n  color: black;\n}\n/* Ajouts sur selectionBloc utiles uniquement sur ce component (pas sur Shareholder) */\n.selectionBloc[data-v-5ef54cfa] {\n  margin-top: 15px;\n  width: 100%;\n}\n.information_check[data-v-5ef54cfa] {\n  color: red;\n}\n.information_check_no[data-v-5ef54cfa] {\n  color: #49A0A2;\n}\n.btn-declare[data-v-5ef54cfa] {\n  background: #1B1918;\n  border-radius: 2px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 28px;\n  text-align: center;\n  color: #FFFFFF;\n  height: 36px;\n  width: 100%;\n  border: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ef54cfa","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/LMSGiframe/SendDocumentsFromApplicationForm.vue
// module id = 1563
// module chunks = 2